// extracted by mini-css-extract-plugin
export var body = "Promotion-module--body--fe7bf";
export var image = "Promotion-module--image--2f35e";
export var promotion = "Promotion-module--promotion--a3e8d";
export var summary = "Promotion-module--summary--ab696";
export var title = "Promotion-module--title--271bd";